import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  budgets: {},
  account: false,
  loading: false,
  formLoading: false,
  error: false,
  success: false,
  exportLoading: false,
  downloadLink: '',
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Budget/index.js